export const getIconClass = (calendarType, isGoogleEvent, eventType_icon) => {
  if (isGoogleEvent) return 'fab fa-google';

  if (eventType_icon) return eventType_icon;

  switch (calendarType) {
    case 'user':
      return 'fas fa-birthday-cake';
    case 'case':
      return 'fas fa-briefcase';
    case 'task':
      return 'fas fa-tasks';
    case 'event':
      return 'far fa-calendar-alt';
    case 'outlook':
      return 'fab fa-microsoft';
    default:
      return 'far fa-calendar-alt';
  }
};

/**
 * Calculate contrasting text color (black or white) based on background luminance
 */
export const getContrastColor = (bgColor) => {
  if (!bgColor) return '#000000';

  let r, g, b;

  if (bgColor.startsWith('rgb')) {
    const matches = bgColor.match(/\d+/g);
    if (matches && matches.length >= 3) {
      r = parseInt(matches[0]);
      g = parseInt(matches[1]);
      b = parseInt(matches[2]);
    } else {
      return '#000000';
    }
  } else {
    const hex = bgColor.replace('#', '');
    r = parseInt(hex.substr(0, 2), 16);
    g = parseInt(hex.substr(2, 2), 16);
    b = parseInt(hex.substr(4, 2), 16);
  }

  // WCAG luminance calculation
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#ffffff';
};
